const routes: Map<string, string> = new Map([['/courses', '/']])

export default defineNuxtRouteMiddleware(to => {
  for (const [route, destination] of routes) {
    if (to.path === route || to.path.startsWith(`${route}/`)) {
      return navigateTo({ ...to, path: destination }, { redirectCode: 308 })
    }
  }
})
